import { render, staticRenderFns } from "./phonenumber.vue?vue&type=template&id=19f857f8&scoped=true"
import script from "./phonenumber.vue?vue&type=script&lang=js"
export * from "./phonenumber.vue?vue&type=script&lang=js"
import style0 from "./phonenumber.vue?vue&type=style&index=0&id=19f857f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f857f8",
  null
  
)

export default component.exports